import { IModel } from '../modelFactory';
import { IModelSet } from '../modelSet';
import { find } from 'lodash';

export interface IAdditionalInfoContainer<TInfo extends IModel> {
    additionalInfo: IModelSet<TInfo>;
    getAdditionalInfo(name: string): TInfo;
    getAdditionalInfoValue(name: string, defaultValue?: string): string;
    setAdditionalInfo(name: string, value: string): TInfo;
}

export default {
	getAdditionalInfo: function (name) {
		if (!this.additionalInfo) { return; }

		return find(this.additionalInfo, { name });
	},
	getAdditionalInfoValue: function (name, defaultValue = '') {
		const info = this.getAdditionalInfo(name);

		return info && info.value || defaultValue;
	},
	setAdditionalInfo: function (name, value) {
		if (!this.additionalInfo) { return; }

		const isUndefined = typeof value === 'undefined' || value === '';
		let result = this.getAdditionalInfo(name);

		if (!result) {
			result = this.additionalInfo.add({ name });
		}

		if (result) {
			if (isUndefined) {
				this.additionalInfo.delete(result.key);
				result = undefined;
			}
			else {
				result.value = value;
			}
		}

		return result;
	},
}